/**
* @file 框架-顶部-APP下载弹窗
* @description 司机端APP下载二维码弹窗，支持复制链接和下载二维码
* @version 1.2.0
* */
<template>
  <el-dialog 
    :visible.sync="visible" 
    width="480px" 
    :close-on-click-modal="false"
    :show-close="false"
    class="app-download-dialog"
    append-to-body
  >
    <!-- 自定义头部 -->
    <div slot="title" class="dialog-header">
      <div class="header-icon">
        <i class="el-icon-mobile-phone"></i>
      </div>
      <div class="header-text">
        <h3>APP下载</h3>
        <p>{{ activeTab === 'driver' ? '扫码下载司机端应用' : '扫码下载渠道端应用' }}</p>
      </div>
      <button class="close-btn" @click="visible = false">
        <i class="el-icon-close"></i>
      </button>
    </div>
    
    <div class="dialog-content">
      <!-- Tab 切换 -->
      <el-tabs v-model="activeTab" @tab-click="handleTabClick" class="app-tabs">
        <el-tab-pane label="司机端应用" name="driver"></el-tab-pane>
        <el-tab-pane label="渠道端应用" name="channel"></el-tab-pane>
      </el-tabs>
      <div class="qrcode-wrapper">
        <div class="qrcode-decoration">
          <div class="corner corner-tl"></div>
          <div class="corner corner-tr"></div>
          <div class="corner corner-bl"></div>
          <div class="corner corner-br"></div>
        </div>
        <div class="qrcode-container">
          <vue-qr 
            class="qr-code-down" 
            :text="currentQrcodeText" 
            :margin="10" 
            colorDark="#7EBF50" 
            :size="200" 
          />
        </div>
        <div class="scan-line"></div>
      </div>
      
      <div class="info-section">
        <div class="info-item">
          <i class="el-icon-mobile-phone"></i>
          <span>支持 Android / iOS</span>
        </div>
        <div class="info-item">
          <i class="el-icon-refresh"></i>
          <span>自动更新</span>
        </div>
      </div>
      
      <div class="button-group">
        <el-button class="btn-copy" @click="copyAndOpen">
          <i class="el-icon-link"></i>
          <span>复制链接</span>
        </el-button>
        <el-button type="primary" class="btn-download" @click="download">
          <i class="el-icon-download"></i>
          <span>下载二维码</span>
        </el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import VueQr from "vue-qr"

export default {
  name: 'AppDownloadDialog',
  components: { VueQr },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    qrcodeText: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      activeTab: 'driver', // 'driver' 或 'channel'
      channelQrcodeText: '' // 渠道app下载路径
    }
  },
  computed: {
    visible: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    // 当前显示的二维码文本
    currentQrcodeText() {
      return this.activeTab === 'driver' ? this.qrcodeText : this.channelQrcodeText
    },
    // 当前下载文件名
    downloadFileName() {
      return this.activeTab === 'driver' ? '司机端APP下载二维码' : '渠道端APP下载二维码'
    }
  },
  watch: {
    visible(val) {
      if (val && this.activeTab === 'channel' && !this.channelQrcodeText) {
        this.loadChannelAppPath()
      }
    }
  },
  methods: {
    /**
     * Tab 切换处理
     */
    handleTabClick(tab) {
      if (tab.name === 'channel' && !this.channelQrcodeText) {
        this.loadChannelAppPath()
      }
    },
    /**
     * 加载渠道app下载路径
     */
    async loadChannelAppPath() {
      try {
        const res = await this.$axios.get('/api/v1/manage/appPath/channel')
        if (res && res.code === 1 && res.data && res.data.channelAppPath) {
          this.channelQrcodeText = res.data.channelAppPath
        } else {
          this.$message.error('获取渠道app下载路径失败')
        }
      } catch (error) {
        console.error('获取渠道app下载路径失败:', error)
        this.$message.error('获取渠道app下载路径失败')
      }
    },
    copyAndOpen() {
      const input = document.createElement('input')
      document.body.appendChild(input)
      input.setAttribute('value', this.currentQrcodeText)
      input.select()
      if (document.execCommand('copy')) {
        document.execCommand('copy')
        this.$message.success("链接已复制")
      } else {
        this.$message.info("该浏览器不支持复制，请手动复制地址栏链接")
      }
      document.body.removeChild(input)

      setTimeout(() => {
        window.open(this.currentQrcodeText)
      }, 500)
    },
    download() {
      let oQrcode = document.getElementsByClassName("qr-code-down")[0]
      let a = document.createElement("a")
      a.href = oQrcode.src
      a.download = this.downloadFileName
      a.click()
    }
  }
}
</script>

<style lang="less" scoped>
.dialog-content {
  padding: 0 20px 20px;
}

.app-tabs {
  margin-bottom: 20px;
  
  /deep/ .el-tabs__header {
    margin: 0 0 20px 0;
  }
  
  /deep/ .el-tabs__item {
    font-size: 14px;
    font-weight: 500;
    padding: 0 20px;
    height: 44px;
    line-height: 44px;
    
    &.is-active {
      color: #7EBF50;
    }
  }
  
  /deep/ .el-tabs__active-bar {
    background-color: #7EBF50;
  }
  
  /deep/ .el-tabs__nav-wrap::after {
    background-color: #e4e7ed;
  }
}

.qrcode-wrapper {
  text-align: center;
  padding: 30px;
  background: linear-gradient(135deg, #f0fff4 0%, #e8f5e9 50%, #f0fff4 100%);
  border-radius: 16px;
  margin-bottom: 20px;
  position: relative;
  overflow: hidden;
  
  // 装饰角
  .qrcode-decoration {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 230px;
    height: 230px;
    pointer-events: none;
    
    .corner {
      position: absolute;
      width: 20px;
      height: 20px;
      border: 3px solid #7EBF50;
      
      &.corner-tl {
        top: 0;
        left: 0;
        border-right: none;
        border-bottom: none;
        border-radius: 4px 0 0 0;
      }
      
      &.corner-tr {
        top: 0;
        right: 0;
        border-left: none;
        border-bottom: none;
        border-radius: 0 4px 0 0;
      }
      
      &.corner-bl {
        bottom: 0;
        left: 0;
        border-right: none;
        border-top: none;
        border-radius: 0 0 0 4px;
      }
      
      &.corner-br {
        bottom: 0;
        right: 0;
        border-left: none;
        border-top: none;
        border-radius: 0 0 4px 0;
      }
    }
  }
  
  .qrcode-container {
    display: inline-block;
    padding: 12px;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 8px 32px rgba(126, 191, 80, 0.2);
    position: relative;
    z-index: 1;
  }
  
  // 扫描线动画
  .scan-line {
    position: absolute;
    top: 30px;
    left: 50%;
    transform: translateX(-50%);
    width: 200px;
    height: 2px;
    background: linear-gradient(90deg, transparent, #7EBF50, transparent);
    animation: scan 2s ease-in-out infinite;
    opacity: 0.8;
  }
}

@keyframes scan {
  0%, 100% {
    top: 30px;
    opacity: 0;
  }
  50% {
    opacity: 0.8;
  }
  100% {
    top: calc(100% - 30px);
    opacity: 0;
  }
}

.info-section {
  display: flex;
  justify-content: center;
  gap: 24px;
  margin-bottom: 24px;
  padding: 16px;
  background: #f8fafc;
  border-radius: 12px;
  
  .info-item {
    display: flex;
    align-items: center;
    font-size: 13px;
    color: #64748b;
    
    i {
      font-size: 16px;
      color: #7EBF50;
      margin-right: 6px;
    }
  }
}

.button-group {
  display: flex;
  justify-content: center;
  gap: 16px;
  
  .el-button {
    min-width: 140px;
    height: 44px;
    border-radius: 22px;
    font-weight: 500;
    font-size: 14px;
    transition: all 0.3s ease;
    
    i {
      margin-right: 6px;
    }
    
    &.btn-copy {
      border: 2px solid #e2e8f0;
      color: #475569;
      
      &:hover {
        border-color: #7EBF50;
        color: #7EBF50;
        background: #f0fff4;
      }
    }
    
    &.btn-download {
      background: linear-gradient(135deg, #7EBF50 0%, #5fa030 100%);
      border: none;
      
      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 6px 20px rgba(126, 191, 80, 0.4);
      }
    }
  }
}
</style>

<!-- 全局样式 -->
<style lang="less">
.app-download-dialog {
  .el-dialog {
    border-radius: 20px;
    overflow: hidden;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
  }
  
  .el-dialog__header {
    padding: 0;
    margin: 0;
  }
  
  .el-dialog__body {
    padding: 0;
  }
  
  .dialog-header {
    display: flex;
    align-items: center;
    padding: 20px 24px;
    background: linear-gradient(135deg, #7EBF50 0%, #5fa030 100%);
    color: #fff;
    position: relative;
    
    .header-icon {
      width: 48px;
      height: 48px;
      border-radius: 12px;
      background: rgba(255, 255, 255, 0.2);
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 16px;
      
      i {
        font-size: 24px;
      }
    }
    
    .header-text {
      flex: 1;
      
      h3 {
        margin: 0;
        font-size: 18px;
        font-weight: 600;
      }
      
      p {
        margin: 4px 0 0;
        font-size: 13px;
        opacity: 0.9;
      }
    }
    
    .close-btn {
      width: 32px;
      height: 32px;
      border-radius: 50%;
      border: none;
      background: rgba(255, 255, 255, 0.2);
      color: #fff;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: all 0.3s ease;
      
      &:hover {
        background: rgba(255, 255, 255, 0.3);
        transform: rotate(90deg);
      }
      
      i {
        font-size: 16px;
      }
    }
  }
}
</style>
